import { addStyling } from '@plone/volto/helpers/Extensions/withBlockSchemaEnhancer';
import { defineMessages } from 'react-intl';

const messages = defineMessages({
  listStyle: {
    id: 'List Style',
    defaultMessage: 'List Style',
  },
  standard: {
    id: 'Standard',
    defaultMessage: 'Standard',
  },
  bigCheckbox: {
    id: 'Big Checkbox',
    defaultMessage: 'Big Checkbox',
  },
});

export const ListStyleSchema = ({ schema, intl }) => {
  addStyling({ schema, intl });

  // Add your custom variant field
  schema.properties.styles.schema.properties.list_style = {
    widget: 'select',
    title: intl.formatMessage(messages.listStyle),
    choices: [
      ['default', intl.formatMessage(messages.standard)],
      ['big-checkbox', intl.formatMessage(messages.bigCheckbox)],
    ],
    default: 'default',
  };
  schema.properties.styles.schema.fieldsets[0].fields.push('list_style');

  return schema;
};
